import { render, staticRenderFns } from "./AddActorProducer.vue?vue&type=template&id=f91cf6fa&scoped=true"
import script from "./AddActorProducer.vue?vue&type=script&lang=js"
export * from "./AddActorProducer.vue?vue&type=script&lang=js"
import style0 from "./AddActorProducer.vue?vue&type=style&index=0&id=f91cf6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91cf6fa",
  null
  
)

export default component.exports